export const ISSUES_ITEM_SMOKING_DYING_REQUEST = "ISSUES_ITEM_SMOKING_DYING_REQUEST";
export const ISSUES_ITEM_SMOKING_DYING_SUCCESS = "ISSUES_ITEM_SMOKING_DYING_SUCCESS";
export const ISSUES_ITEM_SMOKING_DYING_FAILED = "ISSUES_ITEM_SMOKING_DYING_FAILED";
